<template>
    <div>
        <v-skeleton-loader v-if="!items" type="table" />
        <v-data-table
            v-else
            :server-items-length="itemsLength"
            v-model="selectedSync"
            item-key="id"
            :items="items"
            :loading="isLoading"
            show-select
            :headers="headers"
            disable-pagination
            disable-sort
            disable-filtering
            :page.sync="pageSync"
            :footer-props="{ 'items-per-page-options': [10] }"
            no-data-text="В модуле отсутствуют созданные/ выданные «Досудебные уведомления»"
        >
            <template v-for="(header, index) in headers" v-slot:[`header.${header.value}`]>
                <div :key="index" v-html="header.text"></div>
            </template>
            <template v-slot:item.serial_number="{ item }">
                <div>
                    <div class="pb-4">
                        {{ item.serial_number }}
                    </div>
                    <div>
                        {{ item.name }}
                    </div>
                    <div class="py-4">
                        <v-btn v-if="canHandDocument" @click="handDocument(item.id)" rounded x-small color="gray" class="white--text overflow"
                            >Вручить документ потребителю
                        </v-btn>
                    </div>
                    <v-btn @click="openEmailDialog({ id: item.id, email: item.email })" rounded outlined x-small color="gray">Направить по эл почте </v-btn>
                    <div class="py-4">
                        <v-btn v-if="!item.doc_delivery_date" @click="deleteNotice(item.id)" rounded x-small color="gray" class="white--text overflow">
                            Удалить
                        </v-btn>
                    </div>
                    <div class="py-4">
                        <v-btn
                            v-if="item.doc_delivery_date"
                            @click="openWhatsAppDialog({ guid: item.guid, contacts: item.contacts })"
                            rounded
                            outlined
                            x-small
                            color="gray"
                            >Отправить по WhatsApp</v-btn
                        >
                    </div>
                    <div class="py-4">
                        <v-btn v-if="item.eds_signed" @click="getSignedDocument(item.guid)" rounded x-small color="gray" class="white--text overflow"
                            >Скачать подпись</v-btn
                        >
                    </div>
                </div>
            </template>
            <template v-slot:item.doc_create_date="{ item }">
                <div>
                    <div>
                        {{ item.doc_create_date }}
                    </div>
                    <div :class="{ 'shallow--text': !item.doc_delivery_date }">
                        {{ item.doc_delivery_date ? item.doc_delivery_date : 'Не вручено' }}
                    </div>
                </div>
            </template>
            <template v-slot:item.debt="{ item }">
                <div v-for="(debtItem, idx) in item.debt" :key="idx">
                    <div>
                        <div class="font-weight-bold">
                            {{ debtItem['all_dolg'] }}
                        </div>
                        <div>Общая сумма на {{ today }}</div>
                    </div>
                    <br />
                    <div>
                        <div class="font-weight-bold">
                            {{ debtItem['main_dolg'] }}
                        </div>
                        <div>По основным услугам</div>
                    </div>
                    <br />
                    <div>
                        <div class="font-weight-bold">
                            {{ debtItem['fine_dolg'] }}
                        </div>
                        <div>
                            Пеня
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:item.payment="{ item }">
                <div v-for="(debtItem, idx) of item['payment']" :key="idx">
                    <div>
                        <div>{{ debtItem['sum_payment'] }}</div>
                        <div>{{ debtItem['sum_payment'] ? 'Итого за период' : '' }}</div>
                        <br />
                        <div>{{ debtItem['date_payment'] }}</div>
                    </div>
                </div>
            </template>
            <template v-slot:item.doc_signed="{ item }">
                <div>
                    {{ item['doc_signed'] ? 'Да' : 'Нет' }}
                </div>
            </template>
            <template v-slot:footer.prepend>
                <v-spacer />
            </template>
        </v-data-table>
        <PreTrialDialog @sendEmailNotification="$emit('sendEmailNotification', $event)" :id.sync="selectedId" ref="dialog" />
        <WhatsAppDialog @sendWhatsApp="$emit('sendWhatsApp', $event)" ref="whatsAppDialog" />
        <ConfirmDialog :ref="confirmDialogRef" :body="$t(confirmDialogText)" :yesText="$t('Да')" :noText="$t('Нет')" :width="550" />
    </div>
</template>
<script>
import ConfirmDialog from '@/components/ui/ConfirmDialog';
import WhatsAppDialog from '@/components/ui/WhatsAppDialog';
import PreTrialDialog from '@/components/pre-trial-notices/PreTrialDialog.vue';
import { mapGetters } from 'vuex';
import { getToday } from '@/utils';

export default {
    name: 'PreTrialDataTable',
    components: { PreTrialDialog, ConfirmDialog, WhatsAppDialog },
    props: ['headers', 'items', 'selected', 'isLoading', 'itemsLength', 'page', 'isContract'],
    computed: {
        ...mapGetters('auth', ['hasPermissionTo']),
        selectedSync: {
            get() {
                return this.selected;
            },
            set(newValue) {
                this.$emit('update:selected', newValue);
            }
        },
        pageSync: {
            get() {
                return this.page;
            },
            set(val) {
                this.$emit('update:page', val);
            }
        },
        canHandDocument() {
            return this.hasPermissionTo('edit_pre_trial_notice');
        },
        today() {
            return getToday();
        }
    },
    data: function() {
        return {
            confirmDialogText: '',
            confirmDialogRef: 'confirmDialogRef',
            selectedId: null
        };
    },
    methods: {
        openEmailDialog({ id, email }) {
            this.selectedId = id;
            if (email) {
                this.$refs.dialog.$data.email = email;
            }
            this.$refs.dialog.showDialog();
        },
        openWhatsAppDialog({ guid, contacts }) {
            const moduleName = this.isContract ? 'docs/getContractsPreTrialNoticePDFForCustomer' : 'docs/getAccountsPreTrialNoticePDFForCustomer';
            this.$refs.whatsAppDialog.sendWhatsApp(guid, moduleName, contacts);
        },
        handDocument(id) {
            this.$emit('handDocument', id);
        },
        getSignedDocument(guid) {
            this.$emit('getSignedDocument', guid);
        },
        async deleteNotice(record_id) {
            this.confirmDialogText = 'Вы хотите удалить досудебное уведомление?';
            const answer = await this.$refs[this.confirmDialogRef].show();
            if (!answer) return;
            this.$emit('deleteNotice', record_id);
        }
    }
};
</script>

<style></style>
